import React, { useState, Fragment } from "react";
import { DataTable as PrimeDataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Loading from "Components/Loading/Loading";
import NotFound from "Components/NotFound";
import { useTranslation } from "react-i18next";
import { THERE_IS_NO_DATA_FOUND, TOTAL } from "Constant";
import Translate from "Components/Translate";
import { InputText } from "primereact/inputtext";
import { useQuery } from "@tanstack/react-query";
import  axiosClient  from "Services/axiosClient";

// Main SimpleDataTable Component
export default function BadgesDataTable({
  newColumns,
  link,
  localsearch = true,
}) {
  const [search, setSearch] = useState("");
  const { t } = useTranslation();

  const { 
    data, 
    isLoading, 
    isError,
    error 
  } = useQuery({
    queryKey: ['badges', link],
    queryFn: async () => {
      const response = await axiosClient.get(link);
      return response.data;
    }
  });


  if (isLoading) return <Loading />;
  if (isError) {
    console.error('Error fetching badges:', error);
    return <NotFound />;
  }

  const { total: paginationTotalRows, rows: result } = getRows(data);
  const listOfData = filterBySearch(result, search);

  return (
    <Fragment>
      {localsearch && (
        <div style={{ marginBottom: "1%" }}>
          <SearchBar
            search={search}
            setSearch={setSearch}
            total={listOfData?.length}
          />
        </div>
      )}

      <PrimeDataTable
        value={listOfData}
        showGridlines
        stripedRows
        tableStyle={{ minWidth: "50rem" }}
        size={"small"}
        emptyMessage={t(THERE_IS_NO_DATA_FOUND)}
      >
        {newColumns.map((col, i) => (
          <Column
            key={i}
            body={col.body ? col.body : null}
            field={col.selector ? col.selector : null}
            header={t(col.name)}
          />
        ))}
      </PrimeDataTable>
    </Fragment>
  );
}

// Helper function to get rows and total from the fetched data
const getRows = (data) => {
  try {
    const rows = data?.results?.data || [];
    return { total: rows.length, rows };
  } catch (error) {
    return { total: 0, rows: [] };
  }
};

// SearchBar Component
const SearchBar = ({ search, setSearch, total }) => {
  return (
    <div className="p-inputgroup">
      <span className="p-inputgroup-addon">
        <i className="pi pi-search" style={{ marginRight: "8px" }} />
        <Translate>{TOTAL}</Translate>
        <span style={{ marginLeft: "8px" }}>{total}</span>
      </span>
      <InputText
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search..."
        style={{ width: "100%" }}
      />
    </div>
  );
};

const filterBySearch = (array, searchString) => {
  if (!searchString) return array; // If no search string, return the full array

  const lowerCasedSearchString = searchString.toLowerCase();

  return array.filter((item) => {
    // Iterate through all keys of the item
    return Object.values(item).some((value) => {
      // Convert the value to string (in case it's a number or boolean)
      const valueString = String(value).toLowerCase();
      return valueString.includes(lowerCasedSearchString);
    });
  });
};
